import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium mt-5 mb-2 text-[12px]" }, "Ingrese los datos", -1)
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "border-t-2 mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Ver cuenta",
    class: "p-8",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextField, {
          model: _ctx.backCode,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.backCode) = $event)),
          "has-error": _ctx.backCodeFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "number",
          name: "backCode",
          label: 'Código del banco',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.backName,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.backName) = $event)),
          "has-error": _ctx.backNameFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "backName",
          label: 'Nombre del banco',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.accountType,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountType) = $event)),
          "has-error": _ctx.accountTypeFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountType",
          label: 'Tipo de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.accountNumber,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountNumber) = $event)),
          "has-error": _ctx.accountNumberFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "number",
          name: "accountNumber",
          label: 'Número de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.accountOwnerName,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountOwnerName) = $event)),
          "has-error": _ctx.accountOwnerNameFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountOwnerName",
          label: 'Titular de cuenta',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.accountOwnerRut,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accountOwnerRut) = $event)),
          "has-error": _ctx.accountOwnerRutFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountOwnerRut",
          label: 'Rut del titular',
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.accountEmail,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accountEmail) = $event)),
          "has-error": _ctx.accountEmailFieldHasError,
          "error-message": "Es necesario indicar el monto del movimiento",
          type: "text",
          name: "accountEmail",
          label: 'Correo electrónico del titular',
          "hide-details": ""
        }, null, 8, ["model", "has-error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "success ml-auto mt-5 !text-[16px]",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAccount()))
        }, " Activar cuenta ")
      ])
    ]),
    footer: _withCtx(() => [
      _hoisted_4
    ]),
    _: 1
  }, 8, ["visible"]))
}